<template>
  <div class='ad-popup' v-show="advertising.visible">
    <div class='mask' @click="closeAdvertising"></div>
    <img @click="toRecharge" :src="advertising?.image || ''" alt='' />
  </div>
</template>

<script>
import H5EventSDK from '@egame/h5eventsdkcreator';

import { getAdsList } from '@/api';
const h5EventSDK = new H5EventSDK({
  env: process.env.NODE_ENV === 'development' ? 'dev' : 'prod',
  appsec: process.env.NODE_ENV === 'development' ? 'nsaewsdreawERJKs' : 'IUFASwwekj7JHvDSDF',
})
const creatCode = (len = 36) => {
  let str = '';
  const arr = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ];
  for (var i = 0; i < len; i++) {
    var index = Math.floor(Math.random() * 62);
    str += arr[index];
  }
  str += Date.now();
  return str;
};
// 获取url参数
export const getUrlParam = (name, url = location.href) => {
  let pattern = new RegExp('[?|&|#]' + name + '=([^&|#]+)', 'g');
  let matcher = pattern.exec(url);
  let items = '';
  if (null != matcher) {
    try {
      items = decodeURIComponent(decodeURIComponent(matcher[1]));
    } catch (e) {
      try {
        items = decodeURIComponent(matcher[1]);
      } catch (e) {
        items = matcher[1];
      }
    }
  }
  return items;
};
const traceid = creatCode()
const source = getUrlParam('from')
const isPhone = () => {
  var e = navigator.userAgent.toLocaleLowerCase(),
    r = null != e.match(/(ipad|ipod|iphone)/i),
    t = !!e.match(/applewebkit.*mobile.*/),
    n = null != e.toLowerCase().match(
      /(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|win ce)/i),
    x = window.screen.width < 768 //这里加一个屏幕宽度的判断
  n = r || n || t || x;
  return n
}
const sendDataLog = (params) => {
  const linkToken = getUrlParam('linkToken')
  const logsParams = {
    action: 'official_website_open',
    mc: '-1',
    sys: 'official',
    sc: '',
    extc: '',
    appv: '1.0.0',
    traceid: traceid,
    source: isPhone() ? '200' : '100',
    uid: '',
    openid: '',
    ad_id: '',
    token: linkToken
  }
  h5EventSDK.send('event', { ...logsParams, ...(params || {}) })
}
export default {
  name: 'GamePopup',
  props: [
    'siteid'
  ],
  data() {
    return {
      advertising: {
        visible: false,
      }
    }
  },
  mounted() {
    console.log(this.siteid)
    this.getAdvertising();
  },
  methods: {
    closeAdvertising() {
      this.advertising.visible = false
    },
    toRecharge() {
      const searchParams = location.search
      const separator = searchParams.includes('?') ? '&' : '?';
      const link = this.advertising?.loginStatus === 1 && source === 'app' ? `${this.advertising.link}${searchParams}${separator}ad_id=${this.advertising.id}&siteid=${this.siteid}&from=${source}` : this.advertising?.link
      window.open(link, '_blank')
      /* 点击广告位 */
      sendDataLog({
        action: 'official_website_click',
        ad_id: this.advertising.id,
        btn_code: 'ad-popup',
        btn_name: '广告位'
      })
    },
    getAdvertising() {
      getAdsList({
        gameCode: this.siteid,
        adPlace: "game_popup",
        resource: source === 'app' ? 1 : 2
      }).then((res) => {
        const { data, code } = res;
        if (code === 0 && data.length > 0) {
          this.advertising = { ...data[0], visible: true }
          /* 数据上报 */
          sendDataLog({
            ad_id: data[0].id,
            siteid: this.siteid,
          })
        }else{
          /* 数据上报 */
          sendDataLog({
            ad_id: '',
            siteid: this.siteid,
          })
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.ad-popup {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;

  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
  }

  img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-width: 700px;
  }
}
</style>